import _ from 'lodash';
import { useEffect, useState } from 'react';
import { getShop } from 'src/helpers';

const host = process.env.REACT_APP_ADMIN_V3_BASE_URL; // 'https://staging.bc-solutions.net'
const recommendUrl = `${host}/discovery/recommend`;

const useGetRecommendProducts = (
  type: string,
  recommendProducts: any,
  updateRecommendProducts: Function
) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (_.isEmpty(_.get(recommendProducts, type)) && type) {
      handleFetchProducts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recommendProducts, type]);

  const handleFetchProducts = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(recommendUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        },
        body: JSON.stringify({
          shop: getShop(),
          recommendationType: type,
          limit: 4,
          locale: 'en'
        })
      });
      if (response.status === 200) {
        const result = await response.json();
        const newProducts = _.cloneDeep(recommendProducts);
        _.set(newProducts, type, _.get(result, 'products', []));
        updateRecommendProducts(newProducts);
      }
    } catch (e) {
      console.log('ERROR', e);
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading };
};

export default useGetRecommendProducts;
